export default __webpack_public_path__ + "static/char-v-39-0d53541b1f473a869b007a101a11086a.png";